import GLightbox from "glightbox";
import "./styles.scss";

class FsiGlightboxGallery {
  constructor(imageWraps = [...document.querySelectorAll(".img-wrp")], { description = true, loop = false }) {
    this.DOM = { imageWraps };
    this.description = description;
    this.loop = loop;
    this.DOM.elements = this.DOM.imageWraps.map((wrap, index) => {
      const img = wrap.querySelector("img");
      return {
        href: img.src,
        type: "image",
        alt: img.alt,
        description: this.description && img.alt,
      };
    });

    this.init();
    this.addEvents();
  }
  init = () => {
    this.glidebox = GLightbox({ elements: this.DOM.elements, loop: this.loop, slideEffect: "fade" });
  };

  openGlidebox = (event) => {
    const fancyId = event.currentTarget.dataset.fancyid;
    this.glidebox.openAt(fancyId);
  };
  addEvents = () => {
    this.DOM.imageWraps.forEach((element) => {
      element.addEventListener("click", this.openGlidebox);
    });
  };
  removeEvents = () => {
    this.DOM.imageWraps.forEach((element) => {
      element.removeEventListener("click", this.openGlidebox);
    });
  };
  destroy = () => {
    this.removeEvents();
    this.glidebox.destroy();
  };
}

export { FsiGlightboxGallery };
